<template>
  <cargo-cascader
    ref="cascader"
    v-model="value"
    filterable
    v-bind="params.selectProps"
    group-field="type"
    :railway-common-data-source="false"
    @input="onVisibleChange"
  />
</template>

<script>
import Vue from 'vue'
import cargoCascader from '@/components/Cargo/Common/cargoCascader'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default Vue.extend({
  name: 'CargoCascaderEditor',
  components: { cargoCascader },
  data() {
    return {
      value: '',
      selectTypeNames: TYPE_NAMES
    }
  },
  mounted() {
    this.value = this.params.value
    this.$refs.cascader.$refs.elCascader.$refs.input.focus()
  },
  methods: {
    //
    getValue() {
      return this.value
    },
    onVisibleChange() {
      this.params.api.stopEditing()
    }
  }
})
</script>

<style>
</style>
